import { hasProp } from '../../utils';

import type { MenuGroupProps, MenuItemProps, ParentMenuItemProps } from './Menu.types';

export const isMenuGroupProps = (item: MenuItemProps | MenuGroupProps): item is MenuGroupProps => {
  return hasProp(item, 'label');
};

export const isParentMenuItem = (
  item: MenuItemProps | MenuGroupProps
): item is ParentMenuItemProps => {
  return Array.isArray(item.items);
};
